import React, { useEffect, useState, useCallback, useRef } from 'react';
import {
    Modal, Table, Spin, Alert, Input, Space, Button, Typography, Tooltip, Tag, Select,
    message, Dropdown, Checkbox, Card, Row, Col, Image, Divider, Form, InputNumber, Upload
} from 'antd';
import { EditOutlined, EyeOutlined, SaveOutlined, DownloadOutlined, SearchOutlined, PlusOutlined, UploadOutlined, FolderOpenOutlined } from '@ant-design/icons';
import { useTheme } from '../../../context/ThemeContext';
import { useAuth } from '../../../context/AuthContext';
import axios from 'axios';
import { API_BASE_URL as SHARED_API_BASE_URL } from '../../../utils/config';
import { getImageUrls } from '../../../utils/poifotoUtils';
import { trIncludes } from '../../../utils/trText';
import ImageModal from '../modals/ImageModal';

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

function SunumDuzenle() {
    const { darkMode } = useTheme();
    const { user } = useAuth();
    const API_BASE_URL = SHARED_API_BASE_URL;
    const [loading, setLoading] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [generateMapsLoading, setGenerateMapsLoading] = useState(false);
    const [lokasyonLoading, setLokasyonLoading] = useState(false);
    const [lokasyonListesi, setLokasyonListesi] = useState([]);
    const [selectedLokasyonlar, setSelectedLokasyonlar] = useState([]);
    const [sunumData, setSunumData] = useState({}); // { maptriksId: { images: [], map: null, info: {} } }
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [previewPdfUrl, setPreviewPdfUrl] = useState(null);
    const [imageModalConfig, setImageModalConfig] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [firmalar, setFirmalar] = useState([]);
    const [selectedFirma, setSelectedFirma] = useState(null);
    const [firmaLogoUrl, setFirmaLogoUrl] = useState(null);
    const [belediyeLogo, setBelediyeLogo] = useState(null);
    const [belediyeLogoUrl, setBelediyeLogoUrl] = useState(null);
    const [kabinFotolari, setKabinFotolari] = useState([]);
    const [kabinFotoUrls, setKabinFotoUrls] = useState([]);
    const [belediyeNameInput, setBelediyeNameInput] = useState('');
    const [listModalOpen, setListModalOpen] = useState(false);
    const [sunumList, setSunumList] = useState([]);
    const [sunumListLoading, setSunumListLoading] = useState(false);
    const [loadKayitLoading, setLoadKayitLoading] = useState(false);
    const [loadingKayitId, setLoadingKayitId] = useState(null);
    const [savePdfModalOpen, setSavePdfModalOpen] = useState(false);
    const [pdfDosyaAdi, setPdfDosyaAdi] = useState('');
    const [savePdfLoading, setSavePdfLoading] = useState(false);
    const [loadedKayitId, setLoadedKayitId] = useState(null);
    const [loadedKayitDosyaAdi, setLoadedKayitDosyaAdi] = useState('');

    useEffect(() => {
        const fetchAllLokasyonlar = async () => {
            try {
                setLokasyonLoading(true);
                const response = await axios.post(`${API_BASE_URL}/list/execute-query/sozlesme_lokasyonlar`, {
                    params: {}
                }, {
                    headers: {
                        ...(localStorage.getItem('auth_token') && {
                            'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                        })
                    }
                });
                setLokasyonListesi(response.data || []);
            } catch (err) {
                message.error('Lokasyon listesi yüklenirken hata oluştu');
            } finally {
                setLokasyonLoading(false);
            }
        };
        fetchAllLokasyonlar();
    }, []);

    useEffect(() => {
        const fetchFirmalar = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/atm/query?filters=${encodeURIComponent(JSON.stringify([{ "field": "fetch", "value": "firmalar" }]))}`, {
                    headers: {
                        ...(localStorage.getItem('auth_token') && {
                            'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                        })
                    }
                });
                const firmsData = response.data?.data || [];
                const firms = firmsData.map((firm) => ({
                    id: firm.id,
                    name: firm.firma_adi || firm.name || `Firma ${firm.id}`
                }));
                setFirmalar(firms);
            } catch (err) {
                console.error('Firmalar yüklenirken hata:', err);
                setFirmalar([
                    { id: 0, name: 'ATM POINT A.Ş.' },
                    { id: 1, name: 'ATM KİRALAMA A.Ş.' },
                    { id: 2, name: 'ATM İSTANBUL A.Ş.' },
                    { id: 9, name: 'ATM KİRALAMA A.Ş.' },
                    { id: 16, name: 'Neta Kiralama A.Ş' }
                ]);
            }
        };
        fetchFirmalar();
    }, []);

    const handleFirmaSelect = (firmaId) => {
        setSelectedFirma(firmaId);
        const firma_map = { 1: "atmpoint", 2: "masef", 3: "atmistanbul", 10: "atmcity", 17: "neta" };
        const firma_code = firma_map[firmaId] || "atm";
        const logoUrl = `https://dosya.atmturkiye.com/atmpoint/ibbsunum-logo%2F${firma_code}.png`;
        setFirmaLogoUrl(logoUrl);
    };

    const handleBelediyeLogoUpload = async (file) => {
        try {
            const formData = new FormData();
            formData.append('file', file);
            if (belediyeNameInput) {
                formData.append('belediye_name', belediyeNameInput);
            }

            const response = await axios.post(`${API_BASE_URL}/sunum/upload-belediye-logo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...(localStorage.getItem('auth_token') && {
                        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                    })
                }
            });

            if (response.data.success) {
                setBelediyeLogo(file);
                setBelediyeLogoUrl(response.data.logo_url);
                message.success('Belediye logosu yüklendi');
            }
        } catch (err) {
            message.error(err.response?.data?.detail || 'Belediye logosu yüklenirken hata oluştu');
            console.error(err);
        }
        return false;
    };

    const beforeUpload = (file) => {
        const isImage = file.type.startsWith('image/');
        const isValidFormat = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(file.type);

        if (!isImage || !isValidFormat) {
            message.error('Sadece PNG, JPG veya WEBP formatında dosya yükleyebilirsiniz!');
            return false;
        }

        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            message.error('Dosya boyutu 10MB\'dan küçük olmalıdır!');
            return false;
        }

        handleBelediyeLogoUpload(file);
        return false;
    };

    const handleKabinFotoUpload = async (file) => {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(`${API_BASE_URL}/sunum/upload-belediye-logo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...(localStorage.getItem('auth_token') && {
                        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                    })
                }
            });

            if (response.data.success) {
                setKabinFotolari(prev => [...prev, file]);
                setKabinFotoUrls(prev => [...prev, response.data.logo_url]);
                message.success('Kabin fotoğrafı yüklendi');
            }
        } catch (err) {
            message.error(err.response?.data?.detail || 'Kabin fotoğrafı yüklenirken hata oluştu');
            console.error(err);
        }
        return false;
    };

    const beforeKabinFotoUpload = (file) => {
        const isImage = file.type.startsWith('image/');
        const isValidFormat = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(file.type);

        if (!isImage || !isValidFormat) {
            message.error('Sadece PNG, JPG veya WEBP formatında dosya yükleyebilirsiniz!');
            return false;
        }

        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            message.error('Dosya boyutu 10MB\'dan küçük olmalıdır!');
            return false;
        }

        if (kabinFotoUrls.length >= 2) {
            message.warning('Maksimum 2 kabin fotoğrafı yükleyebilirsiniz!');
            return false;
        }

        handleKabinFotoUpload(file);
        return false;
    };

    const handleMapUpload = async (file, maptriksId) => {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(`${API_BASE_URL}/sunum/upload-belediye-logo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...(localStorage.getItem('auth_token') && {
                        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                    })
                }
            });

            if (response.data.success) {
                const updated = { ...sunumData };
                if (updated[maptriksId]) {
                    const currentImages = updated[maptriksId].images || [];
                    let newImages = [...currentImages];
                    if (currentImages.length === 2 && updated[maptriksId].lokasyonResim) {
                        const allImages = getImageUrls(updated[maptriksId].lokasyonResim, maptriksId, { includeFilename: true, useNormalizedId: true });
                        const currentImageIds = currentImages.map(img => img.id);
                        const thirdImage = allImages.find(img => !currentImageIds.includes(img.id));
                        if (thirdImage) {
                            newImages.push({ id: thirdImage.id, url: thirdImage.url });
                        } else if (allImages.length > 2) {
                            newImages.push({ id: allImages[2].id, url: allImages[2].url });
                        }
                    }
                    updated[maptriksId] = {
                        ...updated[maptriksId],
                        map: response.data.logo_url,
                        images: newImages,
                        manualMapUploaded: true,
                        info: {
                            ...updated[maptriksId].info,
                        }
                    };
                    setSunumData(updated);
                    message.success('Harita yüklendi');
                }
            }
        } catch (err) {
            message.error(err.response?.data?.detail || 'Harita yüklenirken hata oluştu');
            console.error(err);
        }
        return false;
    };

    const beforeMapUpload = (file, maptriksId) => {
        const isImage = file.type.startsWith('image/');
        const isValidFormat = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(file.type);

        if (!isImage || !isValidFormat) {
            message.error('Sadece PNG, JPG veya WEBP formatında dosya yükleyebilirsiniz!');
            return false;
        }

        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            message.error('Dosya boyutu 10MB\'dan küçük olmalıdır!');
            return false;
        }

        handleMapUpload(file, maptriksId);
        return false;
    };

    const fetchLokasyonDetay = async (maptriksId) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/atm/query?lokName=${maptriksId}`, {
                headers: {
                    ...(localStorage.getItem('auth_token') && {
                        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                    })
                }
            });
            let lokasyonData = response.data.data;
            if (Array.isArray(lokasyonData)) {
                lokasyonData = lokasyonData.find(item =>
                    (item.MaptriksID)
                ) || {};
            }
            return lokasyonData;
        } catch (err) {
            console.error('Lokasyon detay hatası:', err);
            return null;
        }
    };

    const handleLokasyonSelect = async (selectedIds) => {
        setSelectedLokasyonlar(selectedIds);
        const newData = { ...sunumData };
        for (const id of selectedIds) {
            if (!newData[id]) {
                try {
                    const lokasyonData = await fetchLokasyonDetay(id);
                    if (lokasyonData) {
                        const images = getImageUrls(lokasyonData.lokasyonResim, lokasyonData.MaptriksID || id, { includeFilename: true, useNormalizedId: true });
                        newData[id] = {
                            images: images.slice(0, 2).map(img => ({ id: img.id, url: img.url })),
                            map: null,
                            manualMapUploaded: false,
                            info: {
                                Name: lokasyonData.Name || '',
                                Proje: lokasyonData.Proje || '',
                                Adres: lokasyonData.Adres || lokasyonData.Address || '',
                                İl: lokasyonData.İl || '',
                                İlçe: lokasyonData.İlçe || lokasyonData.District || '',
                                Enlem: lokasyonData.Enlem || '',
                                Boylam: lokasyonData.Boylam || '',
                                Kabin: lokasyonData.ATM_Kabin_Adedi || lokasyonData.Kabin || '',
                            },
                            maptriksId: lokasyonData.MaptriksID || id,
                            lokasyonResim: lokasyonData.lokasyonResim
                        };
                    }
                } catch (err) {
                    console.error(`Lokasyon ${id} yükleme hatası:`, err);
                }
            }
        }
        setSunumData(newData);
    };

    const handleImageSelect = (maptriksId, imageIndex) => {
        const currentData = sunumData[maptriksId];
        if (!currentData) return;
        const allImages = getImageUrls(currentData.lokasyonResim, maptriksId, { includeFilename: true, useNormalizedId: true });
        const maxSelections = currentData.manualMapUploaded ? 3 : 2;
        const sliceLimit = currentData.manualMapUploaded ? 3 : 2;
        setImageModalConfig({
            open: true,
            maptriksId,
            images: allImages,
            startIndex: 0,
            selectionMode: true,
            maxSelections: maxSelections,
            onClose: () => setImageModalConfig(null),
            onSelectionComplete: (selectedImages) => {
                const updated = { ...sunumData };
                const selectedImagesData = selectedImages.slice(0, sliceLimit).map(img => ({ id: img.id, url: img.url }));
                updated[maptriksId] = {
                    ...updated[maptriksId],
                    images: selectedImagesData
                };
                setSunumData(updated);
                message.success(`${selectedImagesData.length} resim seçildi`);
            },
            onImagesChange: (newImages) => {
                const updated = { ...sunumData };
                const selectedImages = newImages.slice(0, sliceLimit).map(img => ({ id: img.id, url: img.url }));
                updated[maptriksId] = {
                    ...updated[maptriksId],
                    images: selectedImages
                };
                setSunumData(updated);
            },
            onActiveImageChange: (idx) => {
                const updated = { ...sunumData };
                const selectedImages = allImages.slice(0, sliceLimit).map(img => ({ id: img.id, url: img.url }));
                if (idx < sliceLimit) {
                    selectedImages[idx] = allImages[idx] ? { id: allImages[idx].id, url: allImages[idx].url } : selectedImages[idx];
                }
                updated[maptriksId] = {
                    ...updated[maptriksId],
                    images: selectedImages
                };
                setSunumData(updated);
            }
        });
    };

    const handleGenerateAllMaps = async () => {
        if (selectedLokasyonlar.length === 0) {
            message.warning('Lütfen en az bir lokasyon seçin');
            return;
        }

        try {
            setGenerateMapsLoading(true);
            message.loading({ content: `${selectedLokasyonlar.length} lokasyon için harita oluşturuluyor...`, key: 'maps', duration: 0 });

            const response = await axios.post(`${API_BASE_URL}/sunum/generate-maps-bulk`, {
                maptriks_ids: selectedLokasyonlar
            }, {
                headers: {
                    ...(localStorage.getItem('auth_token') && {
                        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                    })
                }
            });

            const updated = { ...sunumData };
            let successCount = 0;
            let errorCount = 0;

            Object.entries(response.data.results).forEach(([maptriksId, result]) => {
                if (result.success && result.map_url) {
                    updated[maptriksId] = {
                        ...updated[maptriksId],
                        map: result.map_url,
                        manualMapUploaded: false
                    };
                    successCount++;
                } else {
                    errorCount++;
                }
            });

            setSunumData(updated);

            message.destroy('maps');
            if (errorCount > 0) {
                message.warning(`${successCount} harita oluşturuldu, ${errorCount} harita oluşturulamadı`);
            } else {
                message.success(`${successCount} lokasyon için harita başarıyla oluşturuldu`);
            }
        } catch (err) {
            console.error('Toplu harita oluşturma hatası:', err);
            message.destroy('maps');
            message.error('Haritalar oluşturulurken hata oluştu');
        } finally {
            setGenerateMapsLoading(false);
        }
    };

    const handleInfoUpdate = (maptriksId, field, value) => {
        const updated = { ...sunumData };
        if (updated[maptriksId]) {
            updated[maptriksId] = {
                ...updated[maptriksId],
                info: {
                    ...updated[maptriksId].info,
                    [field]: value
                }
            };
            setSunumData(updated);
        }
    };

    const fetchSunumList = useCallback(async () => {
        try {
            setSunumListLoading(true);
            const response = await axios.get(`${API_BASE_URL}/sunum/list`, {
                headers: { ...(localStorage.getItem('auth_token') && { Authorization: `Bearer ${localStorage.getItem('auth_token')}` }) }
            });
            if (response.data?.success && Array.isArray(response.data.items)) {
                setSunumList(response.data.items);
            } else {
                setSunumList([]);
            }
        } catch (err) {
            message.error(err.response?.data?.detail || 'Kayıtlı sunumlar yüklenemedi');
            setSunumList([]);
        } finally {
            setSunumListLoading(false);
        }
    }, [API_BASE_URL]);

    const handleOpenKayitlar = () => {
        setListModalOpen(true);
        fetchSunumList();
    };

    const handleLoadKayit = async (kayitId) => {
        try {
            setLoadingKayitId(kayitId);
            setLoadKayitLoading(true);
            const response = await axios.get(`${API_BASE_URL}/sunum/kayit/${kayitId}`, {
                headers: { ...(localStorage.getItem('auth_token') && { Authorization: `Bearer ${localStorage.getItem('auth_token')}` }) }
            });
            if (!response.data?.success || !response.data?.data) {
                message.error('Sunum verisi alınamadı');
                return;
            }
            const data = response.data.data;
            const dosyaAdi = response.data.dosya_adi ?? '';
            setLoadedKayitDosyaAdi(dosyaAdi.replace(/\.pdf$/i, ''));
            setBelediyeNameInput(data.belediye_name || '');
            setFirmaLogoUrl(data.firma_logo_url || null);
            setBelediyeLogoUrl(data.belediye_logo_url || null);
            setKabinFotoUrls(data.kabin_foto_urls || []);
            const locs = data.locations || [];
            const ids = locs.map((l) => Number(l.maptriks_id));
            setSelectedLokasyonlar(ids);
            setLoadedKayitId(kayitId);

            const baseImgUrl = 'https://dosya.atmturkiye.com/atmpoint/ibbsunum';
            const newData = {};
            for (let i = 0; i < locs.length; i++) {
                const loc = locs[i];
                const id = Number(loc.maptriks_id);
                const images = Array.isArray(loc.images)
                    ? loc.images.map((img) => {
                        const imgId = typeof img === 'object' && img?.id != null ? img.id : img;
                        const url = typeof img === 'object' && img?.url ? img.url : (imgId ? `${baseImgUrl}/${id}/${imgId}/rs:fill:300:200/q:70` : '');
                        return { id: imgId, url };
                    })
                    : [];
                newData[id] = {
                    images,
                    map: loc.map || null,
                    info: loc.info || {},
                    manualMapUploaded: !!loc.manualMapUploaded,
                    maptriksId: id,
                    lokasyonResim: loc.lokasyonResim || null
                };
            }
            setSunumData(newData);
            setListModalOpen(false);

            for (const id of ids) {
                if (!newData[id].lokasyonResim) {
                    const lokasyonData = await fetchLokasyonDetay(id);
                    if (lokasyonData?.lokasyonResim != null) {
                        setSunumData((prev) => ({
                            ...prev,
                            [id]: { ...prev[id], lokasyonResim: lokasyonData.lokasyonResim }
                        }));
                    }
                }
            }
            message.success('Sunum yüklendi');
        } catch (err) {
            message.error(err.response?.data?.detail || 'Sunum yüklenemedi');
        } finally {
            setLoadKayitLoading(false);
        }
    };

    const handleSavePdfOpen = () => {
        if (selectedLokasyonlar.length === 0) {
            message.warning('Lütfen en az bir lokasyon seçin');
            return;
        }
        setPdfDosyaAdi(loadedKayitDosyaAdi || '');
        setSavePdfModalOpen(true);
    };

    const handleSavePdfSubmit = async () => {
        try {
            setSavePdfLoading(true);
            const payload = {
                locations: selectedLokasyonlar.map((id) => {
                    const data = sunumData[id];
                    return {
                        maptriks_id: id,
                        images: data?.images ?? [],
                        map: data?.map ?? null,
                        info: data?.info ?? {},
                        manualMapUploaded: data?.manualMapUploaded ?? false
                    };
                }),
                belediye_name: belediyeNameInput,
                firma_logo_url: firmaLogoUrl,
                belediye_logo_url: belediyeLogoUrl,
                kabin_foto_urls: kabinFotoUrls,
                pdf_dosya_adi: pdfDosyaAdi.trim() || undefined,
                kayit_id: loadedKayitId || undefined
            };
            await axios.post(`${API_BASE_URL}/sunum/save-multi`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    ...(localStorage.getItem('auth_token') && { Authorization: `Bearer ${localStorage.getItem('auth_token')}` })
                }
            });
            setSavePdfModalOpen(false);
            setPdfDosyaAdi('');
            setLoadedKayitId(null);
            setLoadedKayitDosyaAdi('');
            message.success(loadedKayitId ? 'Sunum güncellendi' : 'Sunum PDF olarak kaydedildi');
            fetchSunumList();
        } catch (err) {
            message.error(err.response?.data?.detail || 'Kaydetme hatası');
        } finally {
            setSavePdfLoading(false);
        }
    };

    const handlePreview = async () => {
        try {
            setPreviewLoading(true);
            const payload = {
                locations: selectedLokasyonlar.map(id => {
                    const data = sunumData[id];
                    return {
                        maptriks_id: id,
                        images: data?.images?.map(img => img.id) || [],
                        map: data?.map || null,
                        info: data?.info || {},
                        manualMapUploaded: data?.manualMapUploaded || false
                    };
                }),
                belediye_name: belediyeNameInput,
                firma_logo_url: firmaLogoUrl,
                belediye_logo_url: belediyeLogoUrl,
                kabin_foto_urls: kabinFotoUrls
            };

            const response = await axios.post(`${API_BASE_URL}/sunum/preview-multi`, payload, {
                headers: {
                    ...(localStorage.getItem('auth_token') && {
                        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                    })
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            setPreviewPdfUrl(url);
            setPreviewModalOpen(true);
        } catch (err) {
            message.error('Önizleme oluşturulurken hata oluştu');
        } finally {
            setPreviewLoading(false);
        }
    };

    const handleDownload = async () => {
        try {
            setDownloadLoading(true);
            const payload = {
                locations: selectedLokasyonlar.map(id => {
                    const data = sunumData[id];
                    return {
                        maptriks_id: id,
                        images: data?.images?.map(img => img.id) || [],
                        map: data?.map || null,
                        info: data?.info || {},
                        manualMapUploaded: data?.manualMapUploaded || false
                    };
                }),
                belediye_name: belediyeNameInput,
                firma_logo_url: firmaLogoUrl,
                belediye_logo_url: belediyeLogoUrl,
                kabin_foto_urls: kabinFotoUrls
            };

            const response = await axios.post(`${API_BASE_URL}/sunum/generate-multi-pdf`, payload, {
                headers: {
                    ...(localStorage.getItem('auth_token') && {
                        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                    })
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `sunum_${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            message.success('PDF başarıyla indirildi');
        } catch (err) {
            message.error('PDF indirme sırasında hata oluştu');
        } finally {
            setDownloadLoading(false);
        }
    };

    const columns = [
        {
            title: 'Lokasyon Adı',
            dataIndex: 'Name',
            key: 'Name',
            width: 200,
            render: (text) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{text}</span>
        },
        {
            title: 'MaptriksID',
            dataIndex: 'maptriksID',
            key: 'maptriksID',
            width: 120,
            render: (text) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{text}</span>
        },
        {
            title: 'Proje',
            dataIndex: 'Proje',
            key: 'Proje',
            width: 180,
            render: (text) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{text || '-'}</span>
        },
        {
            title: 'İl',
            dataIndex: 'İl',
            key: 'İl',
            width: 150,
            render: (text) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{text || '-'}</span>
        },
    ];

    const rowSelection = {
        selectedRowKeys: selectedLokasyonlar.map(id => String(id)),
        onChange: (selectedRowKeys, selectedRows) => {
            const currentSelected = new Set(selectedLokasyonlar.map(id => String(id)));
            const visibleSelected = new Set(selectedRowKeys);
            const allSelected = new Set([...currentSelected]);
            filteredLokasyonListesi.forEach(record => {
                const key = String(record.MaptriksID || record.ID || record.id || record.maptriksID || record.maptriksId);
                if (visibleSelected.has(key)) {
                    allSelected.add(key);
                } else if (currentSelected.has(key)) {
                    allSelected.delete(key);
                }
            });
            const numericIds = Array.from(allSelected).map(id => Number(id));
            handleLokasyonSelect(numericIds);
        },
        getCheckboxProps: (record) => {
            const key = record.MaptriksID || record.ID || record.id || record.maptriksID || record.maptriksId;
            return {
                name: String(key),
            };
        },
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const filteredLokasyonListesi = lokasyonListesi.filter(lokasyon => {
        if (!searchText) return true;
        const maptriksId = String(lokasyon.maptriksID);
        return trIncludes(lokasyon.Name, searchText) || maptriksId.includes(searchText) || trIncludes(lokasyon['Proje'], searchText);
    });

    return (
        <div style={{
            padding: 24,
            background: darkMode ? '#1b1d22' : '#f5f5f5',
            minHeight: '100vh'
        }}>
            <Card
                style={{
                    marginBottom: 24,
                    background: darkMode ? '#25272b' : '#fff',
                    borderColor: darkMode ? '#3a3d45' : '#d9d9d9'
                }}
            >
                <Space direction="vertical" style={{ width: '100%' }} size="large">
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                            <Text strong style={{ color: darkMode ? '#fff' : '#000' }}>
                                Lokasyon Seçimi:
                            </Text>
                            <Input
                                placeholder="Lokasyon adı, proje, ID ara"
                                prefix={<SearchOutlined />}
                                value={searchText}
                                onChange={handleSearchChange}
                                allowClear
                                size="small"
                                style={{ width: '100%', maxWidth: 300 }}
                            />
                        </div>
                        <Table
                            rowSelection={rowSelection}
                            columns={columns}
                            dataSource={filteredLokasyonListesi}
                            rowKey={(record) => {
                                const key = record.MaptriksID || record.ID || record.id || record.maptriksID || record.maptriksId;
                                return String(key);
                            }}
                            loading={lokasyonLoading}
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: false
                            }}
                            scroll={{ x: 'max-content' }}
                            className={darkMode ? 'dark-table' : ''}
                            style={{
                                marginTop: 16,
                                background: darkMode ? '#25272b' : '#fff'
                            }}
                        />
                    </div>

                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '4px'
                    }}>
                        <Space wrap size="small" style={{ flex: 1, minWidth: '180px' }}>
                            <Button
                                type="default"
                                icon={<DownloadOutlined />}
                                onClick={handleGenerateAllMaps}
                                loading={generateMapsLoading}
                                disabled={selectedLokasyonlar.length === 0 || selectedLokasyonlar.every(id => sunumData[id]?.map)}
                            >
                                Harita Oluştur
                            </Button>
                            <Select
                                placeholder="Firma Seçin"
                                style={{ width: 200, minWidth: 100 }}
                                value={selectedFirma}
                                onChange={handleFirmaSelect}
                                showSearch
                                filterOption={(input, option) =>
                                    trIncludes(option?.children ?? '', input)
                                }
                            >
                                {firmalar.map(firma => (
                                    <Option key={firma.id} value={firma.id}>
                                        {firma.name}
                                    </Option>
                                ))}
                            </Select>
                            {firmaLogoUrl && (
                                <img
                                    src={firmaLogoUrl}
                                    alt="Firma Logosu"
                                    style={{ height: 32, maxWidth: 100, objectFit: 'contain' }}
                                    onError={() => setFirmaLogoUrl(null)}
                                />
                            )}
                            <Input
                                type="text"
                                value={belediyeNameInput}
                                onChange={(e) => setBelediyeNameInput(e.target.value)}
                                placeholder="Belediye Adı"
                                style={{ minWidth: 100 }}
                            >

                            </Input>
                            <Upload
                                beforeUpload={beforeUpload}
                                showUploadList={false}
                                accept="image/png,image/jpeg,image/jpg,image/webp"
                            >
                                <Button
                                    type="default"
                                    icon={<UploadOutlined />}
                                >
                                    Belediye Logosu
                                </Button>
                            </Upload>
                            {belediyeLogoUrl && (
                                <img
                                    src={belediyeLogoUrl}
                                    alt="Belediye Logosu"
                                    style={{ height: 32, maxWidth: 100, objectFit: 'contain' }}
                                    onError={() => setBelediyeLogoUrl(null)}
                                />
                            )}
                            <Upload
                                beforeUpload={beforeKabinFotoUpload}
                                showUploadList={false}
                                accept="image/png,image/jpeg,image/jpg,image/webp"
                                multiple={false}
                            >
                                <Button
                                    type="default"
                                    icon={<UploadOutlined />}
                                    disabled={kabinFotoUrls.length >= 2}
                                >
                                    Kabin Fotoğrafı ({kabinFotoUrls.length}/2)
                                </Button>
                            </Upload>
                            {kabinFotoUrls.length > 0 && (
                                <Space wrap size="small">
                                    {kabinFotoUrls.map((url, index) => (
                                        <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                                            <img
                                                src={url}
                                                alt={`Kabin Fotoğrafı ${index + 1}`}
                                                style={{ height: 32, maxWidth: 100, objectFit: 'contain', marginRight: 8 }}
                                                onError={() => {
                                                    setKabinFotoUrls(prev => prev.filter((_, i) => i !== index));
                                                    setKabinFotolari(prev => prev.filter((_, i) => i !== index));
                                                }}
                                            />
                                            <Button
                                                type="text"
                                                danger
                                                size="small"
                                                style={{ position: 'absolute', top: -8, right: -8, padding: 0, minWidth: 16, height: 16 }}
                                                onClick={() => {
                                                    setKabinFotoUrls(prev => prev.filter((_, i) => i !== index));
                                                    setKabinFotolari(prev => prev.filter((_, i) => i !== index));
                                                }}
                                            >
                                                ×
                                            </Button>
                                        </div>
                                    ))}
                                </Space>
                            )}
                        </Space>
                        <Space wrap size="small" style={{ marginTop: '8px' }}>
                            <Button
                                type="default"
                                icon={<FolderOpenOutlined />}
                                onClick={handleOpenKayitlar}
                            >
                                Sunumlar
                            </Button>
                            <Button
                                type="primary"
                                icon={<EyeOutlined />}
                                onClick={handlePreview}
                                loading={previewLoading}
                            >
                                Önizleme
                            </Button>
                            <Button
                                type="default"
                                icon={<SaveOutlined />}
                                onClick={handleSavePdfOpen}
                                disabled={selectedLokasyonlar.length === 0}
                            >
                                Kaydet
                            </Button>
                            <Button
                                type="default"
                                icon={<DownloadOutlined />}
                                onClick={handleDownload}
                                loading={downloadLoading}
                            >
                                İndir
                            </Button>
                        </Space>
                    </div>
                </Space>
            </Card>

            {selectedLokasyonlar.length > 0 && (
                <div>
                    <Title level={3} style={{ color: darkMode ? '#fff' : '#000', marginBottom: 16 }}>
                        Seçilen Lokasyonlar ({selectedLokasyonlar.length})
                    </Title>
                    <Row gutter={[16, 16]}>
                        {selectedLokasyonlar.map((id) => {
                            const data = sunumData[id];
                            if (!data) return null;

                            return (
                                <Col xs={24} sm={24} md={12} lg={8} key={id}>
                                    <Card
                                        title={data.info.Name || `Lokasyon ${id}`}
                                        style={{
                                            background: darkMode ? '#25272b' : '#fff',
                                            borderColor: darkMode ? '#3a3d45' : '#d9d9d9'
                                        }}
                                    >
                                        <Space direction="vertical" style={{ width: '100%' }} size="middle">
                                            {/* Resimler */}
                                            <div>
                                                <Text strong style={{ color: darkMode ? '#fff' : '#000' }}>
                                                    {data.manualMapUploaded ? '3 Resim:' : '2 Resim:'}
                                                </Text>
                                                <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                                                    {(data.manualMapUploaded ? [0, 1, 2] : [0, 1]).map((idx) => (
                                                        <div
                                                            key={idx}
                                                            style={{
                                                                width: 80,
                                                                height: 60,
                                                                border: '1px solid #d9d9d9',
                                                                borderRadius: 4,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer',
                                                                background: darkMode ? '#1b1d22' : '#fafafa'
                                                            }}
                                                            onClick={() => handleImageSelect(id, idx)}
                                                        >
                                                            {data.images[idx] ? (
                                                                <img
                                                                    src={data.images[idx].url}
                                                                    alt={`Resim ${idx + 1}`}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        objectFit: 'cover',
                                                                        borderRadius: 4
                                                                    }}
                                                                />
                                                            ) : (
                                                                <PlusOutlined style={{ color: '#999' }} />
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                                <Button
                                                    size="small"
                                                    icon={<EditOutlined />}
                                                    onClick={() => handleImageSelect(id, 0)}
                                                    style={{ marginTop: 8 }}
                                                >
                                                    Resimleri Değiştir
                                                </Button>
                                            </div>

                                            {/* Harita */}
                                            <div>
                                                <Text strong style={{ color: darkMode ? '#fff' : '#000' }}>
                                                    Harita:
                                                </Text>
                                                <div style={{ marginTop: 8 }}>
                                                    {data.map ? (
                                                        <img
                                                            src={data.map}
                                                            alt="Harita"
                                                            style={{
                                                                width: '100%',
                                                                maxHeight: 150,
                                                                objectFit: 'cover',
                                                                borderRadius: 4
                                                            }}
                                                        />
                                                    ) : (
                                                        <Upload
                                                            beforeUpload={(file) => beforeMapUpload(file, id)}
                                                            showUploadList={false}
                                                            accept="image/png,image/jpeg,image/jpg,image/webp"
                                                        >
                                                            <Button
                                                                type="default"
                                                                icon={<UploadOutlined />}
                                                            >
                                                                Harita Yükle
                                                            </Button>
                                                        </Upload>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Lokasyon Bilgileri */}
                                            <div>
                                                <Text strong style={{ color: darkMode ? '#fff' : '#000' }}>
                                                    Lokasyon Bilgileri:
                                                </Text>
                                                <Space direction="vertical" style={{ width: '100%', marginTop: 8 }} size="small">
                                                    <Input
                                                        placeholder="Lokasyon Adı"
                                                        value={data.info.Name}
                                                        onChange={(e) => handleInfoUpdate(id, 'Name', e.target.value)}
                                                        size="small"
                                                    />
                                                    <Input
                                                        placeholder="Adres"
                                                        value={data.info.Adres}
                                                        onChange={(e) => handleInfoUpdate(id, 'Adres', e.target.value)}
                                                        size="small"
                                                    />
                                                    <Input
                                                        placeholder="İl"
                                                        value={data.info.İl}
                                                        onChange={(e) => handleInfoUpdate(id, 'İl', e.target.value)}
                                                        size="small"
                                                    />
                                                    <Input
                                                        placeholder="İlçe"
                                                        value={data.info.İlçe}
                                                        onChange={(e) => handleInfoUpdate(id, 'İlçe', e.target.value)}
                                                        size="small"
                                                    />
                                                    <InputNumber
                                                        placeholder="Enlem"
                                                        value={data.info.Enlem}
                                                        onChange={(value) => handleInfoUpdate(id, 'Enlem', value)}
                                                        style={{ width: '100%' }}
                                                        size="small"
                                                    />
                                                    <InputNumber
                                                        placeholder="Boylam"
                                                        value={data.info.Boylam}
                                                        onChange={(value) => handleInfoUpdate(id, 'Boylam', value)}
                                                        style={{ width: '100%' }}
                                                        size="small"
                                                    />
                                                </Space>
                                            </div>
                                        </Space>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>

                    {/* Lokasyon Bilgisi Tablosu */}
                    <Card
                        style={{
                            marginTop: 24,
                            background: darkMode ? '#25272b' : '#fff',
                            borderColor: darkMode ? '#3a3d45' : '#d9d9d9'
                        }}
                    >
                        <Title level={4} style={{ color: darkMode ? '#fff' : '#000', marginBottom: 16 }}>
                            LOKASYON BİLGİSİ
                        </Title>
                        <Table
                            columns={[
                                {
                                    title: 'No',
                                    key: 'no',
                                    width: 60,
                                    render: (_, __, index) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{index + 1}</span>
                                },
                                {
                                    title: 'Lokasyon Adı',
                                    dataIndex: 'name',
                                    key: 'name',
                                    width: 250,
                                    render: (text) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{text || '-'}</span>
                                },
                                {
                                    title: 'İl',
                                    dataIndex: 'il',
                                    key: 'il',
                                    width: 120,
                                    render: (text) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{text || '-'}</span>
                                },
                                {
                                    title: 'İlçe',
                                    dataIndex: 'ilce',
                                    key: 'ilce',
                                    width: 150,
                                    render: (text) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{text || '-'}</span>
                                },
                                {
                                    title: 'Kabin',
                                    dataIndex: 'kabin',
                                    key: 'kabin',
                                    width: 100,
                                    render: (text) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{text || '-'}</span>
                                },
                                {
                                    title: 'Adres',
                                    dataIndex: 'adres',
                                    key: 'adres',
                                    width: 300,
                                    render: (text) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{text || '-'}</span>
                                },
                                {
                                    title: 'Enlem Boylam',
                                    key: 'enlem-boylam',
                                    width: 200,
                                    render: (_, record) => {
                                        const coords = record.enlem && record.boylam
                                            ? `${record.enlem}, ${record.boylam}`
                                            : '-';
                                        return <span style={{ color: darkMode ? '#fff' : '#000' }}>{coords}</span>;
                                    }
                                }
                            ]}
                            dataSource={selectedLokasyonlar.map((id) => {
                                const data = sunumData[id];
                                return {
                                    key: id,
                                    kabin_tipi: data?.info?.KabinTipi || '-',
                                    name: data?.info?.Name || '-',
                                    il: data?.info?.İl || '-',
                                    ilce: data?.info?.İlçe || '-',
                                    kabin: data?.info?.Kabin || '-',
                                    adres: data?.info?.Adres || '-',
                                    enlem: data?.info?.Enlem || '',
                                    boylam: data?.info?.Boylam || '',
                                    manualMapUploaded: data?.manualMapUploaded || false
                                };
                            })}
                            pagination={false}
                            size="small"
                            scroll={{ x: 'max-content' }}
                            className={darkMode ? 'dark-table' : ''}
                            style={{
                                background: darkMode ? '#25272b' : '#fff'
                            }}
                        />
                    </Card>
                </div>
            )}

            {/* Image Modal */}
            {imageModalConfig && (
                <ImageModal
                    open={imageModalConfig.open}
                    onClose={imageModalConfig.onClose}
                    images={imageModalConfig.images}
                    startIndex={imageModalConfig.startIndex}
                    maptriksId={imageModalConfig.maptriksId}
                    onImagesChange={imageModalConfig.onImagesChange}
                    onActiveImageChange={imageModalConfig.onActiveImageChange}
                    selectionMode={imageModalConfig.selectionMode}
                    maxSelections={imageModalConfig.maxSelections}
                    onSelectionComplete={imageModalConfig.onSelectionComplete}
                />
            )}

            {/* Preview Modal */}
            <Modal
                open={previewModalOpen}
                onCancel={() => {
                    setPreviewModalOpen(false);
                    if (previewPdfUrl) {
                        URL.revokeObjectURL(previewPdfUrl);
                        setPreviewPdfUrl(null);
                    }
                }}
                footer={null}
                width={900}
                title="PDF Önizleme"
            >
                {previewPdfUrl && (
                    <iframe
                        src={previewPdfUrl}
                        style={{ width: '100%', height: '80vh', border: 'none' }}
                    />
                )}
            </Modal>

            {/* Kayıtlı Sunumlar Modal */}
            <Modal
                open={listModalOpen}
                onCancel={() => setListModalOpen(false)}
                footer={null}
                width={700}
                title="Kayıtlı Sunumlar"
            >
                <Spin spinning={sunumListLoading}>
                    <Table
                        dataSource={sunumList}
                        rowKey="id"
                        pagination={{ pageSize: 10 }}
                        scroll={{ x: 'max-content' }}
                        columns={[
                            {
                                title: 'Dosya adı',
                                dataIndex: 'dosya_adi',
                                key: 'dosya_adi',
                                render: (t) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{t}</span>
                            },
                            {
                                title: 'Oluşturma tarihi',
                                dataIndex: 'olusturma_tarihi',
                                key: 'olusturma_tarihi',
                                width: 180,
                                render: (t) => <span style={{ color: darkMode ? '#fff' : '#000' }}>{t ? new Date(t).toLocaleString('tr-TR') : '-'}</span>
                            },
                            {
                                title: '',
                                key: 'action',
                                width: 100,
                                render: (_, record) => (
                                    <Button
                                        type="link"
                                        size="small"
                                        onClick={(e) => { e.stopPropagation(); handleLoadKayit(record.id); }}
                                        loading={loadKayitLoading && loadingKayitId === record.id}
                                    >
                                        Aç
                                    </Button>
                                )
                            }
                        ]}
                        onRow={(record) => ({
                            onClick: () => handleLoadKayit(record.id),
                            style: { cursor: 'pointer' }
                        })}
                    />
                </Spin>
            </Modal>

            {/* PDF Kaydet Modal */}
            <Modal
                open={savePdfModalOpen}
                onCancel={() => { setSavePdfModalOpen(false); setPdfDosyaAdi(''); }}
                onOk={handleSavePdfSubmit}
                okText="Kaydet"
                confirmLoading={savePdfLoading}
                title="PDF olarak kaydet"
            >
                <Space direction="vertical" style={{ width: '100%' }} size="middle">
                    <Text type="secondary">Dosya adı (MinIO'da bu isimle kaydedilir). Boş bırakırsanız otomatik isim kullanılır.</Text>
                    <Input
                        placeholder="Örn: Ankara_Çankaya_Sunum"
                        value={pdfDosyaAdi}
                        onChange={(e) => setPdfDosyaAdi(e.target.value)}
                        allowClear
                    />
                </Space>
            </Modal>
        </div>
    );
}

if (typeof document !== 'undefined') {
    const styleId = 'sunum-duzenle-dark-styles';
    if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
            .dark-table .ant-table {
                background: #25272b !important;
                color: #fff !important;
            }
            .dark-table .ant-table-thead > tr > th {
                background: #1b1d22 !important;
                color: #fff !important;
                border-bottom: 1px solid #3a3d45 !important;
            }
            .dark-table .ant-table-tbody > tr > td {
                background: #25272b !important;
                color: #fff !important;
                border-bottom: 1px solid #3a3d45 !important;
            }
            .dark-table .ant-table-tbody > tr:hover > td {
                background: #2d3035 !important;
            }
            .dark-table .ant-table-tbody > tr.ant-table-row-selected > td {
                background: #1a3a5c !important;
            }
            .dark-table .ant-pagination-item {
                background: #25272b !important;
                border-color: #3a3d45 !important;
            }
            .dark-table .ant-pagination-item a {
                color: #fff !important;
            }
            .dark-table .ant-pagination-item-active {
                background: #1677ff !important;
                border-color: #1677ff !important;
            }
            .dark-table .ant-pagination-prev,
            .dark-table .ant-pagination-next {
                color: #fff !important;
            }
            .dark-table .ant-pagination-prev .ant-pagination-item-link,
            .dark-table .ant-pagination-next .ant-pagination-item-link {
                background: #25272b !important;
                border-color: #3a3d45 !important;
                color: #fff !important;
            }
            .dark-table .ant-checkbox-wrapper {
                color: #fff !important;
            }
            .dark-table .ant-checkbox-inner {
                background-color: #25272b !important;
                border-color: #3a3d45 !important;
            }
            .dark-table .ant-checkbox-checked .ant-checkbox-inner {
                background-color: #1677ff !important;
                border-color: #1677ff !important;
            }
        `;
        document.head.appendChild(style);
    }
}

export default SunumDuzenle;
